"use client";

import { Avatar as AvatarPrimitive } from "@base-ui/react/avatar";
import * as React from "react";

import { cn } from "@/utils/lib";
import { resolveClassName } from "@/utils/resolve-class-name";

const Avatar = ({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root>) => (
  <AvatarPrimitive.Root
    className={(state) =>
      cn(
        "relative flex size-10 shrink-0 overflow-hidden rounded-full",
        resolveClassName(className, state),
      )
    }
    {...props}
  />
);
Avatar.displayName = "Avatar";

const AvatarImage = ({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) => (
  <AvatarPrimitive.Image
    className={(state) =>
      cn("aspect-square size-full", resolveClassName(className, state))
    }
    {...props}
  />
);
AvatarImage.displayName = "AvatarImage";

const AvatarFallback = ({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) => (
  <AvatarPrimitive.Fallback
    className={(state) =>
      cn(
        "flex size-full items-center justify-center rounded-full bg-muted",
        resolveClassName(className, state),
      )
    }
    {...props}
  />
);
AvatarFallback.displayName = "AvatarFallback";

export { Avatar, AvatarFallback, AvatarImage };
